import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setShowLogIn, setShowSignUp } from "../app/Slices/Ui";
import DropDown from "./DropDown";

const dropdownData = ["Image", "Sound", "Text", "Video"];

function Navbar() {
  /*
   * Toggle to show/hide navbar on hamburger click
   */
  const [toggle, setToggle] = useState(false);

  /*
   *To show/hide dropdown
   */
  const [showDropDown, setShowDropDown] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  return (
    <div className="container h-20 mx-auto ">
      <nav className="bg-white flex flex-wrap justify-between items-center h-full py-2.5 ">
        <Link to={"/"}>
          <div className="flex items-center">
            <img src="/genshare.svg" className="mr-3 w-16	h-16" alt="GenShare" />
            <span className="self-center text-2xl font-semibold">GenShare</span>
          </div>
        </Link>
        <div className="flex lg:order-2">
          {user ? (
            /*
             *Logged In User
             */
            <img
              className="w-12	h-12"
              src="https://api-private.atlassian.com/users/8f525203adb5093c5954b43a5b6420c2/avatar"
              alt="avatar"
            />
          ) : (
            /*
             *User not logged In
             */
            <div className="hidden sm:block">
              <button
                onClick={() => dispatch(setShowLogIn(true))}
                type="button"
                className="py-2 px-7 text-white bg-blue border hover:bg-white hover:text-blue font-semibold	 rounded-lg font-semibold text-center mr-3 "
              >
                Log in
              </button>

              <button
                onClick={() => dispatch(setShowSignUp(true))}
                type="button"
                className="py-2 px-5 text-blue bg-white border border-blue hover:bg-blue hover:text-white font-semibold	 rounded-lg font-semibold text-center mr-3 "
              >
                Sign Up
              </button>
            </div>
          )}
          <button
            onClick={() => {
              setToggle(!toggle);
            }}
            data-collapse-toggle="mobile-menu-4"
            type="button"
            className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="mobile-menu-4"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            {!toggle ? (
              /*
               *Hamburger Button
               */
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                ></path>
              </svg>
            ) : (
              /*
               *Close Button
               */
              <svg
                className=" w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            )}
          </button>
        </div>
        <div
          className={` justify-between bg-white z-10 pb-8 lg:pb-0 items-center w-full lg:flex lg:w-auto lg:order-1 ${
            !toggle && "hidden"
          }`}
        >
          <ul className="flex flex-col mt-4  lg:flex-row lg:space-x-8 lg:mt-0 lg:text-sm lg:font-medium">
            <li
              className="font-medium text-base mx-2 block py-2 pr-4 pl-3 "
              aria-current="page"
            >
              <Link to={"/library"}>Library</Link>
            </li>
            <li
              className="font-medium text-base mx-2 block py-2 pr-4 pl-3 "
              aria-current="page"
            >
              <Link to={"/gallery"}>Gallery</Link>
            </li>

            <li
              className={`flex justify-between	 lg:justify-between	 cursor-pointer mx-2 relative items-center font-medium text-base block py-2 pr-4 pl-3  ${
                showDropDown && "border border-gray  rounded-full "
              }`}
              aria-current="page"
              onClick={() => {
                setShowDropDown(!showDropDown);
              }}
            >
              Studio
              {!showDropDown ? (
                /*
                 * Arrow Down
                 */ <svg
                  className="ml-1 w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              ) : (
                /*
                 * Arrow Up
                 */
                <svg
                  className="ml-2 w-4 h-4 ml-16"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              )}
              {/* content */}
              <div
                id="dropdownNavbar"
                className={`absolute top-11 left-0 w-full lg:-left-3 bg-white px-2 z-10 lg:w-44 bg-white rounded border border-gray shadow ${
                  !showDropDown && "hidden"
                } `}
              >
                <DropDown dropdownData={dropdownData} />
              </div>
            </li>
            {!user && (
              <li
                className=" block sm:hidden flex justify-center font-medium text-base mx-2 block py-2 pr-4 pl-3 "
                aria-current="page"
              >
                <button
                  onClick={() => {
                    setToggle(false);
                    dispatch(setShowLogIn(true));
                  }}
                  type="button"
                  className="py-2 px-7 text-white bg-blue border hover:bg-white hover:text-blue font-semibold	 rounded-lg font-semibold text-center mr-3 "
                >
                  Log in
                </button>

                <button
                  onClick={() => {
                    setToggle(false);
                    dispatch(setShowSignUp(true));
                  }}
                  type="button"
                  className="py-2 px-5 text-blue bg-white border border-blue hover:bg-blue hover:text-white font-semibold	 rounded-lg font-semibold text-center mr-3 "
                >
                  Sign Up
                </button>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
